import http from '@/services/http'
import data from '@/services/data'

export default {
  async loadInit () {
    let request
    try {
      request = await data.get('/init.json')
    } catch (error) {
      request = http.get('/init')
    }
    return request
  }
}
